import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { WarehouseStockApprovalListComponent, WarehouseStockApprovalUpdateComponent, WarehouseStockApprovalViewEditComponent, WarehouseStoclApprovalModalComponent } from '@inventory-components/WarehouseStockApproval';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';

const warehouseStockApprovalModuleRoutes: Routes = [
    { path: '', component: WarehouseStockApprovalListComponent, data: { title: 'Stock Take Initiation List' }, canActivate: [AuthGuard] },
    { path: 'list', component: WarehouseStockApprovalListComponent, data: { title: 'Stock Take Initiation List' }, canActivate: [AuthGuard] },
    { path: 'view', component: WarehouseStockApprovalViewEditComponent, data: { title: 'Stock Take Initiation View' }, canActivate: [AuthGuard] },
    { path: 'update', component: WarehouseStockApprovalUpdateComponent, data: { title: 'Stock Take Initiation Update' }, canActivate: [AuthGuard] }
];
const warehouseStockApprovalDeclarationComponents = [
    WarehouseStockApprovalListComponent,
    WarehouseStockApprovalViewEditComponent, 
    WarehouseStockApprovalUpdateComponent,
    WarehouseStoclApprovalModalComponent
 ]; 
@NgModule({
    declarations: [ ...warehouseStockApprovalDeclarationComponents],
    imports: [
        CommonModule,
        MatRadioModule,
        MatDialogModule,
        MatIconModule,
        SharedModule,
        LayoutModule,
        RouterModule.forChild(warehouseStockApprovalModuleRoutes)
    ],
    entryComponents: [WarehouseStoclApprovalModalComponent]
})

export class WarehouseStockApprovalModule { }